var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTgNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04616 19.7918C14.8771 17.2595 18.7588 15.5768 20.708 14.7605C26.2557 12.4448 27.4218 12.045 28.1715 12.0283C28.3381 12.0283 28.7046 12.0616 28.9545 12.2616C29.1545 12.4282 29.2044 12.6447 29.2377 12.8113C29.2711 12.9779 29.3044 13.3278 29.2711 13.5943C28.9712 16.7597 27.6717 24.4398 27.0053 27.9717C26.7221 29.4711 26.1724 29.9708 25.6392 30.0208C24.4731 30.1208 23.5901 29.2545 22.4739 28.5214C20.708 27.3719 19.725 26.6556 18.0091 25.5227C16.0266 24.2232 17.3094 23.5069 18.4422 22.3407C18.7421 22.0408 23.8567 17.3761 23.9566 16.9596C23.9733 16.9096 23.9733 16.7097 23.8567 16.6097C23.74 16.5098 23.5734 16.5431 23.4402 16.5764C23.2569 16.6097 20.4581 18.4756 15.0103 22.1574C14.2107 22.7072 13.4943 22.9738 12.8446 22.9571C12.1282 22.9404 10.7621 22.5573 9.72921 22.2241C8.47973 21.8242 7.48015 21.6077 7.56345 20.908C7.61343 20.5414 8.11322 20.1749 9.04616 19.7918Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04616 19.7918C14.8771 17.2595 18.7588 15.5768 20.708 14.7605C26.2557 12.4448 27.4218 12.045 28.1715 12.0283C28.3381 12.0283 28.7046 12.0616 28.9545 12.2616C29.1545 12.4282 29.2044 12.6447 29.2377 12.8113C29.2711 12.9779 29.3044 13.3278 29.2711 13.5943C28.9712 16.7597 27.6717 24.4398 27.0053 27.9717C26.7221 29.4711 26.1724 29.9708 25.6392 30.0208C24.4731 30.1208 23.5901 29.2545 22.4739 28.5214C20.708 27.3719 19.725 26.6556 18.0091 25.5227C16.0266 24.2232 17.3094 23.5069 18.4422 22.3407C18.7421 22.0408 23.8567 17.3761 23.9566 16.9596C23.9733 16.9096 23.9733 16.7097 23.8567 16.6097C23.74 16.5098 23.5734 16.5431 23.4402 16.5764C23.2569 16.6097 20.4581 18.4756 15.0103 22.1574C14.2107 22.7072 13.4943 22.9738 12.8446 22.9571C12.1282 22.9404 10.7621 22.5573 9.72921 22.2241C8.47973 21.8242 7.48015 21.6077 7.56345 20.908C7.61343 20.5414 8.11322 20.1749 9.04616 19.7918Z",
    fill: "url(#paint0_linear_3969_31062)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3969_31062",
    x1: 18.4127,
    y1: 12.0283,
    x2: 18.4127,
    y2: 29.8864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgNew);
export default __webpack_public_path__ + "static/media/tg_new.3b310c9bc5e757c04522493e0f2d7268.svg";
export { ForwardRef as ReactComponent };